<!--渠道积分-->
<template>
  <div class="com-table balance border">
    <div class="com-title pr">渠道积分</div>
    <search :data="search.list" @click="updateConditions"></search>
    <el-table
      v-loading="table.loading"
      :data="table.list"
      style="width: 100%">
      <template slot="empty">
        <no-data></no-data>
      </template>
      <el-table-column
        prop="sources"
        label="类型">
      </el-table-column>
      <el-table-column
        prop="variational"
        label="渠道积分">
      </el-table-column>
      <el-table-column
        prop="publishTime"
        label="日期">
      </el-table-column>
    </el-table>
    <el-pagination
      class="pagination"
      layout="total, sizes, prev, pager, next, jumper"
      :current-page.sync="table.pagination.page"
      :total="table.pagination.totalRow"
      :page-size="table.pagination.pageSize"
      :page-sizes="table.pagination.pageSizes"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange">
    </el-pagination>
  </div>
</template>
<script>
  import Search from '@/components/common/Search.vue'
  import { SEARCH_CONDITION } from '@/models/client/channel-credit'
  import Api from '@/api/client/channel-credit'
  import ResponseParse from '@/utils/response-parse'

  export default {
    created () {
      this.search.list = SEARCH_CONDITION
      this.getType()
      this.requestList()
      this.list = ''
    },
    components: {
      Search
    },
    data () {
      return {
        search: {
          list: [],
          condition: {}
        },
        table: {
          loading: true,
          list: [],
          pagination: {}
        }
      }
    },
    methods: {
      requestList () {
        this.table.loading = true
        let search = Object.assign({}, this.table.pagination, this.search.condition)
        Api.list({'search': search}, response => {
          let status = response.data.code
          let body = response.data.data
          if (status === '200') {
            this.table.list = body
            this.table.pagination = ResponseParse.pagination(response.headers)
          } else {
            this.table.list = []
          }
        })
        this.table.loading = false
      },
      getType () {
        Api.sourcesList(response => {
          let status = response.status
          let body = response.data.list
          if (status >= 200 && status <= 204) {
            let project = []
            this.list = body
            body.forEach((item, index) => {
              project.push({value: index, label: item.sources})
            })
            this.search.list[0].config.list = project
          }
        })
      },
      handleSizeChange (val) {
        this.table.pagination.pageSize = val
        this.requestList()
      },
      handleCurrentChange (val) {
        this.table.pagination.page = val
        this.requestList()
      },
      updateConditions (conditions) {
        this.table.pagination.page = 1
        const date = conditions.date || []
        this.search.condition = Object.assign({}, conditions, {startTime: date[0], endTime: date[1]}, {sources: this.list[conditions.sources].sources})
        this.requestList()
      }
    }
  }
</script>
<style scoped lang="scss">
  @import '../../assets/styles/env';

</style>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/client/ChannelCredit.vue